import {
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  inputProps?: {
    dir?: "ltr" | "rtl";
    style?: {
      textAlign?: "left" | "right";
    };
  };
};

const RHFTextField = ({
  name,
  label,
  placeholder,
  type = "text",
  inputProps,
}: Props) => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl fullWidth error={!!errors[name]}>
      {label && (
        <FormLabel
          sx={(theme) => ({
            mb: 0.75,
            color: theme.palette.primary.main,
            fontSize: "14px",
            "&.Mui-error": {
              color: theme.palette.primary.main,
            },
          })}
        >
          {t(label)}
        </FormLabel>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            type={type}
            placeholder={t(placeholder ?? "")}
            error={!!errors[name]}
            inputProps={{
              ...inputProps,
              style: {
                ...inputProps?.style,
                fontSize: "14px",
              },
            }}
            sx={(theme) => ({
              "& .MuiOutlinedInput-root": {
                bgcolor: "#3A3A3A",
                borderRadius: 1,
                color: "#fff",

                "& fieldset": {
                  borderColor: "#555",
                },

                "&:hover fieldset": {
                  borderColor: "#777",
                },

                "&.Mui-focused fieldset": {
                  borderColor: theme.palette.primary.main,
                },
              },
            })}
          />
        )}
      />

      <FormHelperText error>
        {t((errors[name]?.message as string) || "")}
      </FormHelperText>
    </FormControl>
  );
};

export default RHFTextField;
